// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XVFrJ","action":"Header_action__SbaQX","button":"Header_button__kwXlK"};